import { download } from "@/components/Joyspace/api/file";
import { getShareIdByPermissionType } from "@/components/Joyspace/api/permissions";
import { joyspacePermissionType } from "@/components/Joyspace/config/permissions.config";
import { sizeToStr } from "@/components/UploadBox/utils";
import { useNavigator } from "@/utils/NetworkCheck";
import { BatchDownloadItem, ErrorCode, Status } from "../type";

const getDocumentDownloadPath = async (pageId: string) => {
  const res = await download(pageId);
  return res;
};

// const checkNetworkLine = (options: any) => {
//   !useNavigator.onLine && options.onError(ErrorCode.NETWORK_ERROR);
//   return useNavigator.onLine;
// };

// const checkDownloadPermission = (pageId: string, options: any) => {
//   const currentPermission: any = getShareIdByPermissionType(pageId);
//   if (currentPermission === joyspacePermissionType.ReadDel) {
//     options.onError(ErrorCode.NO_PERMISSION);
//     return false;
//   }
//   return true;
// };

// const checkDownloadError = (pageId: string, options: any) => {
//   return checkNetworkLine(options) && checkDownloadPermission(pageId, options);
// };

const convertDownloadUnit = (totalBytes: number) => {
  return sizeToStr(totalBytes);
};

const createDownloadItem = (item: BatchDownloadItem) => {
  return {
    id: item.id,
    pageId: (item as any).page_id,
    title: item.title,
    currentSize: "0kb",
    size: convertDownloadUnit(Number(item.size || 0)),
    currentProgress: 0,
    imgUrl: (item as any).icon_url,
    status: Status.WAITING,
    index: 0,
    applyFn: Status.WAITING,
    path: item.path,
    gid: item.gid,
    onProgress: () => {},
    onStart: () => {}
  };
};

const getDownloadFileStatus = async (url: string): Promise<number> => {
  return new Promise((resolve) => {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.onload = function () {
      resolve(this.status);
    };
    xhr.send();
  });
};

// // 截取文档标题
// const substringPageTitle = (title = '') => {
//     let len = title.length;
//     if (len <= 150) {
//         return title || '';
//     }
//     let startStr = title.substring(0, 25);
//     let lastIndex = len - 25;
//     let endStr = title.substring(lastIndex, len);
//     // eslint-disable-next-line no-debugger
//     // debugger;
//     console.log(startStr, 'startStrstartStrstartStrstartStrstartStr');
//     console.log(endStr, 'endStrendStrendStrendStrendStrendStrendStr');
//     console.log(lastIndex, 'lastIndexlastIndexlastIndexlastIndex', len, title);
//     return `无标题.txt`;
// };

export {
  getDocumentDownloadPath,
  //   checkNetworkLine,
  //   checkDownloadPermission,
  //   checkDownloadError,
  convertDownloadUnit,
  createDownloadItem,
  getDownloadFileStatus
  // substringPageTitle,
};
